import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react'

const baseQuery = retry(
  fetchBaseQuery({
    baseUrl: process.env.solanaUrl,
    prepareHeaders: (headers) => {
      headers.set('Access-Control-Allow-Origin', '*')
      headers.set('x-api-key', process.env.solanaApiKey as string)
      return headers
    },
  }),
  {
    maxRetries: 3,
  },
)

export const solanaApi = createApi({
  baseQuery,
  reducerPath: 'solanaApi',
  endpoints: () => ({}),
})
